export enum OptoutOption {
  all = 'ALL',
  marketing = 'MARKETING',
  none = 'NONE'
}
